import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbField } from "abreact/form/AbField";
import * as AbFormHooks from "abreact/form/AbFormHooks";
import { AbDecimalDataValueInput } from "abreact/input/AbDecimalDataValueInput";
import * as React from "react";
export function AbDecimalField(props) {
  const viewModel = AbFormHooks.useDataValueFieldViewModel("ab-decimal-field", props);
  if (!viewModel) {
    return null;
  }
  return /*#__PURE__*/React.createElement(AbField, _extends({}, viewModel.fieldProps, {
    singleLine: true
  }), /*#__PURE__*/React.createElement(AbDecimalDataValueInput, _extends({}, viewModel.inputProps, {
    decimalPlaces: props.decimalPlaces,
    min: props.min,
    max: props.max
  })));
}
//# sourceMappingURL=AbDecimalField.js.map
